import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './css/NewPred.css';
import './css/Summary.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import labService from './labService';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import token_red from './images/token-red.png'
import token_green from './images/token_nqtb.png'
import HashLoader from "react-spinners/HashLoader";
import Visualization from './Visualization.js';


const Summary = ({ isCollapsed, toggleSidebar }) => {
    const navigate = useNavigate();
    const { pk } = useParams();
    const [modelsList, setModelsList] = useState([]);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedModelId, setSelectedModelId] = useState(null);
    const [analysis, setAnalysis] = useState(null);
    const [loadPage, setloadPage] = useState(true);
    const [visualizationType, setVisualizationType] = useState('inconclusive');

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('user'))?.access;

        if (!token) {
            setError("You must be logged in to view this page.");
            return;
        }

        const fetchAnalysis = async () => {
            try {
                const response = await labService.getAnalysisDetail(pk, token);
                const data = response.data;

                if (data.anal_status === "Done") {
                    navigate('/laboratory');
                } else {
                    setAnalysis(data);
                    setVisualizationType(data.visualization_type || 'inconclusive');

                    // Extract model IDs from selected_models object
                    const ids = Object.keys(data.selected_models);
                    if (ids.length > 0) {
                        const response2 = await labService.getModelsArray(token, ids);
                        setModelsList(response2.data);
                    } else {
                        setModelsList([]);
                    }
                }
            } catch (error) {
                console.error("Error fetching analysis:", error);
                setError("Failed to fetch analysis.");
            } finally {
                setloadPage(false);
            }
        };

        fetchAnalysis();
    }, [pk, navigate]);



    useEffect(() => {
        const fetchUserData = async () => {
            const userData = localStorage.getItem('user');
            if (!userData) {
                setLoading(false);
                return;
            }

            const parsedUserData = JSON.parse(userData);
            const token = parsedUserData.access;
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await labService.getUserInfo(token);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user data', error);
            } finally {
                setLoading(false);
            }
            
        };

        fetchUserData();
    }, []);


    const closeSelectModels = () => {
        navigate('/laboratory');
    };

    const goBackEdit = () => {
        const { endpoint_type, id } = analysis; // Destructure the needed values
        navigate(`/choose-model/${endpoint_type}/${id}`);
    };

    const handleRunPredictions = async () => {
        // Retrieve user data from localStorage
        const userData = localStorage.getItem('user');
        if (!userData) {
            setError("You must be logged in to run predictions.");
            return;
        }
    
        const parsedUserData = JSON.parse(userData);
        const token = parsedUserData.access;
        if (!token) {
            setError("Invalid authentication token.");
            return;
        }

        if (user && user.coins < totalCost) return;
    
        // Prepare the data payload
        const data = { ml_models: analysis.selected_models };
    
        try {
            // Make the POST request to run predictions
            const response = await labService.runCalculation(pk, token);
            
            // Check if the response contains a redirect URL
            if (response.status === 201 || response.status === 200) {
                console.log(response.data);
                console.log("Redirecting to:", response.data.redirect_url);
                navigate(response.data.redirect_url);
            }
        } catch (error) {
            console.error('Error running predictions:', error);
            // Optionally, you can set an error message to display to the user
            setError('Failed to run predictions. Please try again.');
        }
    }; 
    

    const totalCost = modelsList.reduce((sum, model) => {
        const cellLines = analysis?.selected_models?.[model.id] || [];
        return sum + (model.model_price || 0) * cellLines.length;
    }, 0);



    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <div className='new-pred-container'>
                    <div className='np-tabs'>
                        <div className='x'>
                            <button onClick={closeSelectModels} className='x-but'>
                                <FontAwesomeIcon className='icon-x' icon={faX} />
                            </button>
                        </div>
                        <div className='np-steps sum-tab-1'>
                            <p className='p-step'>STEP 1</p>
                            <p className='mar-btm-few'>Select endpoints</p>
                        </div>
                        <div className='np-steps sum-tab-2'>
                            <p className='p-step'>STEP 2</p>
                            <p className='mar-btm-few'>Define Nanoform</p>
                        </div>
                        <div className='np-steps sum-tab-3'>
                            <p className='p-step'>STEP 3</p>
                            <p className='mar-btm-few'>Summary</p>
                        </div>
                        <div className='np-steps'>
                            <p className='p-step'>STEP 4</p>
                            <p className='mar-btm-few'>Results</p>
                        </div>
                
                    </div>

                    
                    <div className='sm-content'>
                        {loadPage ? (
                        <div className='loader-div'>
                            <HashLoader className='loader' size={120} color='#0b5578' />
                        </div>
                        ) : ( <>
                        <div className='np-conte'>

                            <div className='anal-name-div'>
                                <p className='main-text anal-name-sum'>Analysis name:</p>
                                <p className='name-anal-sum'>
                                    {analysis ? analysis.name : 'Loading...'}
                                </p>
                            </div>

                            <div className='comp-mdl-list'>               
                                <div className="compound-info-sum">
                                    <p className='main-text yo-compound-sum mrg-smil'>Your Nanoform</p>
                                    <div className='structer-image-sum'> 
                                        <div className='smiles-notat-div-sum'>
                                            {analysis ? (
                                                <div className='nanoform-info'>
                                                    <div className="info-row">
                                                        <span className="info-key">Shape</span>
                                                        <span className="info-value">{analysis.visualization_type || "N/A"}</span>
                                                    </div>

                                                    {analysis.descriptors && Object.entries(analysis.descriptors).map(([key, value]) => (
                                                        <div className="info-row" key={key}>
                                                        <span className="info-key">{key.replace(/_/g, ' ')}</span>
                                                        <span className="info-value">{value}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p>Loading...</p>
                                            )}
                                        </div>
                                    </div>
                                    
                                    <div className='mod-lst-div-1'>
                                        <p className='main-text sel-mod-sum'>Selected models</p>
                                        {modelsList.map((model) => {
                                            const cellLines = analysis?.selected_models?.[model.id] || [];

                                            return cellLines.length > 0 ? (
                                                cellLines.map((cellLine, idx) => (
                                                    <div
                                                        key={`${model.id}-${idx}`}
                                                        className="model-row-sum"
                                                    >
                                                        <p className='mdl-name-sum'>
                                                            {model.model_name} – {cellLine}
                                                        </p>
                                                    </div>
                                                ))
                                            ) : (
                                                <div
                                                    key={model.id}
                                                    className="model-row-sum"
                                                >
                                                    <p className='mdl-name-sum'>
                                                        {model.model_name}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {user && user.coins < totalCost && (
                                        <div>
                                            <p className="not-enough-tokens">You do not have enough tokens to make this amount of predictions.</p>
                                            <p className='grey-text'>Go to the <span className='boldy'>Wallet tab</span> to top up your account with tokens.</p>
                                        </div>
                                    )}
                                    <div className='cost-div-sum'>
                                        <p className={` ${user && user.coins < totalCost ? 'not-enough-tokens-sum' : 'cost-sum'}`}>
                                            {`Total cost: ${totalCost} ${totalCost === 1 ? "token" : "tokens"}`}
                                        </p>
                                        <img
                                            className="token-cost-sum"
                                            src={user && user.coins < totalCost ? token_red : token_green}
                                            alt="token icon"
                                        />
                                    </div>
                                                 
                                </div>

                                <div className='visualization-area-sum' style={{ flex: '2' }}>
                                    <Visualization
                                        core={{ name: 'TiO2' }}
                                        coreModification={null}
                                        coreColor="#b6b6b6" 
                                        surfaceFunctionalization={false}
                                        surfaceFunctionalizationColor="#9ed2ff"
                                        lineColor="#7fb13a"
                                        isNanoformImageGenerated={false}
                                        visualizationType={visualizationType}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className='btns-sum'>
                            <button className="go-back-btn-sum" onClick={goBackEdit}>Back</button>
                            <button onClick={handleRunPredictions} className={`${user && user.coins >= totalCost && totalCost>0 ? 'run-but-ready-sum' : 'run-but-sum'}`}>Start prediction</button>
                            <div style={{ width: '188px' }}></div> {/* Spacer to balance the layout */}
                        </div>
                        </>)}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Summary;
